import React, { ComponentType } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { useAuth } from '@presentation/hooks'
import { PermissaoRequisito } from '@core/models/entities'

type Props = {
  component: ComponentType
  permission?: PermissaoRequisito
}

const ProtectedRoute: React.FC<Props> = ({
  component: RouteComponent,
  permission
}) => {
  const location = useLocation()
  const { getCurrentAccount, hasExplicitPermission } = useAuth()

  const currentAccount = getCurrentAccount()

  if (currentAccount === undefined) {
    return <Navigate to="/login" replace state={{ from: location }} />
  }

  const canAccess = permission
    ? hasExplicitPermission(permission)
    : currentAccount.permissoes.some(permissao =>
        location.pathname.startsWith(permissao.nome)
      )

  return canAccess ? (
    <RouteComponent />
  ) : (
    <Navigate replace to="/pagina-nao-encontrada" />
  )
}

export default ProtectedRoute
